module.exports = __webpack_public_path__ + "img/beginners-guide-to-bf4-by-asal.1759b67e.jpg";